module.exports = __webpack_public_path__ + "static/img/child_porn_1_tc.0e4ff2a3.png";